import type { JSX } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CircularProgress from '@mui/material/CircularProgress';

type WozSyncingModalProps = {
  open: boolean;
};

export const WozSyncingModal = ({ open }: WozSyncingModalProps): JSX.Element => (
  <Dialog open={open} disableEscapeKeyDown slotProps={{ backdrop: { onClick: (e) => e.stopPropagation() } }}>
    <DialogContent>
      <div className='flex flex-col items-center gap-4 py-2 px-4'>
        <CircularProgress />
        <p className='text-body'>Gegevens opslaan…</p>
      </div>
    </DialogContent>
  </Dialog>
);
